import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img 
              src="https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/521ce2f64a3197aeacbf96106048b2bd.jpeg" 
              alt="Esfera Records Logo" 
              className="h-14 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('artistas')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Artistas
            </button>
            <button 
              onClick={() => scrollToSection('testimonios')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Testimonios
            </button>
            <button 
              onClick={() => scrollToSection('estudio')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Estudio
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="bg-gradient-to-r from-teal-600 to-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:from-teal-700 hover:to-teal-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contacto
            </button>
          </div>

          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('artistas')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer"
            >
              Artistas
            </button>
            <button 
              onClick={() => scrollToSection('testimonios')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer"
            >
              Testimonios
            </button>
            <button 
              onClick={() => scrollToSection('estudio')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer"
            >
              Estudio
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="block w-full text-left bg-gradient-to-r from-teal-600 to-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium cursor-pointer"
            >
              Contacto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
